import {FilterType, getIntervalDate, GridToolsFilterModel} from 'gelios-ng-admin-components';

export class SingleUnitLogGridFilterModel extends GridToolsFilterModel {

  constructor(
    protected unitId: number) {
    super();
    this.fields = {
      unit_id: {
        type: FilterType.TextField,
        value: this.unitId,
        onChange: () => {
        },
        isVisible: () => false
      },
      timestamp: {
        type: FilterType.DateIntervalField,
        value: getIntervalDate(7),
        onChange: () => {
        },
        isVisible: () => false
      },
    };
  }
}

